<template>
  <div>
    <div>
      <v-card style="padding-left: 10">
        <v-card-title
          style="background-color: #82a1d0"
          background-color="primary"
          class="d-flex justify-center align-center"
        >
          <v-text-field
            dense
            solo
            v-model="search"
            append-icon="mdi-magnify"
            :label="$tc('commons.search')"
            single-line
            hide-details
            class="search"
          ></v-text-field>
        </v-card-title>
        <v-divider />
        <v-data-table
          :search="search"
          :hide-default-footer="true"
          disable-pagination
          :headers="headers"
          :items="items"
          fixed-header
          :height="'100%'"
          class="elevation-3 dataTable"
          style="min-width: 100%"
        >
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import ToolbarTitles from "../Complement/ToolbarTitles.vue";
export default {
  components: { ToolbarTitles },
  props: {
    headers: Array,
    items: Array,
    title: String,
  },

  data() {
    return {
      search: "",
    };
  },
};
</script>

<style scoped>
.dataTable {
  overflow-y: scroll !important;
  height: 60vh;
}
.search {
  max-width: 500px;
}
::v-deep .v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: scroll;
  scrollbar-width: unset;
}
</style>
